import React from 'react';
import Styles from './expense-item-styles.scss';
import { formatAccountBalance } from '@/presentation/utils/money-utils';
export const ExpenseItem = ({ item: { title, amount, percentage, color } }) => {
    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    return (React.createElement("div", { className: Styles.expenseItemComp },
        React.createElement("div", { className: Styles.circle },
            React.createElement("span", { style: {
                    backgroundColor: color
                } })),
        React.createElement("div", { className: Styles.text },
            React.createElement("h3", null, capitalize(title))),
        React.createElement("div", { className: Styles.percentage, style: {
                color
            } }, !isNaN(Number(percentage)) ? React.createElement("h3", null,
            percentage,
            "%") : React.createElement("h3", null, "0%")),
        React.createElement("div", { className: Styles.value },
            React.createElement("h3", null,
                formatAccountBalance(amount),
                " KV"))));
};
